/// <amd-module name="VSSUI/TextFilterBarItem" />
export { TextFilterBarItem } from "./Components/TextFilterBarItem/TextFilterBarItem";
export { KeywordFilterBarItem, InlineKeywordFilterBarItem } from "./Components/TextFilterBarItem/KeywordFilterBarItem";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { ITextFilterBarProps, IInlineKeywordFilterBarItemProps } from "./Components/TextFilterBarItem/TextFilterBarItem.Props";
